import TaskRunner from '../base/TaskRunner';
import FileInput from '../components/FileInput';
import FieldMasker from '../components/FieldMasker';
import FieldValidation from '../components/FieldValidation';

TaskRunner.add(() => {
    document.querySelectorAll('input').forEach(inp => {
        switch(inp.type){
            case 'file':
                new FileInput(inp);
                break;
            case 'tel':
                new FieldMasker(inp, 'ruPhone');
                break;
        }

        let validator = inp.getAttribute('data-validation');

        if(validator != null){
            new FieldValidation(inp, validator);
        }
    });

    document.querySelectorAll('[data-validation-unlock]').forEach(form => {
        let unlockTarg = document.getElementById(form.getAttribute('data-validation-unlock'));

        form.addEventListener('input', (e) => {
            let allFields = form.querySelectorAll('input,textfield');
            let allValid = true;

            for(let inp of allFields){
                if(!inp.checkValidity()){
                    allValid = false;
                    break;
                }
            }

            unlockTarg.disabled = !allValid;
        });
    });
});